export default {
	home: {
		afunOriginals: "AFun اوریجنل",
		slots: "سلاٹس",
		liveCasino: "لائیو کیسینو",
		casualGames: "آرام گیمز",
		newReleases: "نئی ریلیز",
		casinoTitle: "کیسینو",
		casinoDesc: "ہزاروں سلاٹس، لائیو ڈیلرز اور ٹیبل گیمز کے ساتھ کیسینو گیمز کا لطف اٹھائیں",
		goToCasino: "کیسینو پر جائیں",
		sportsTitle: "کھیل",
		sportsDesc: "فٹ بال، باسکٹ بال، ٹینس اور مزید کھیلوں پر بہترین مشکلات کے ساتھ شرط لگائیں",
		goToSports: "کھیلوں پر جائیں",
		liveTitle: "لائیو",
		liveDesc: "لائیو ڈیلرز اور انٹرایکٹو گیمنگ تجربے کے ساتھ حقیقی وقت کی کارروائی",
		goToLive: "لائیو پر جائیں",
		latestBetRace: "تازہ ترین شرط اور ریس",
		sports: "کھیل",
		latestBets: "تازہ ترین شرطیں",
		game: "گیم",
		player: "کھلاڑی",
		bet: "شرط",
		multiplier: "ضارب",
		profit: "منافع",
		top10Games: "ٹاپ 10 گیمز",
		vip: "VIP",
		rewards: "انعامات",
		affiliate: "ایفلی एट",
		promotion: "پروموشن"
	},

	latestBetRace: {
		title: "گیم لیڈربورڈ گرینڈ پرکس",
		playerBetRank: "آج کے کھلاڑیوں کے بیٹس",
		playerWinRank: "آج کے کھلاڑیوں کی جیت",
		gameBetRank: "آج کے گیم بیٹس",
		gameWinRank: "آج کے گیم ریٹرنز",
		player: "کھلاڑی",
		game: "گیم",
		bet: "بیٹ",
		profit: "جیت",
		ratio: "ادائیگی کا تناسب",
		totalBet: "کل بیٹ",
		totalReturn: "کل ریٹرن",
		maxBet: "زیادہ سے زیادہ بیٹ",
		gameRatio: "ریٹرن %",
		noData: "کوئی ڈیٹا دستیاب نہیں",
	},

	GameClassify: {
		casinoTitle: "کیسینو",
		casinoDesc: "بہترین فراہم کنندگان کے ساتھ کیسینو گیمز کا لطف اٹھائیں",
		casinoBtn: "کیسینو پر جائیں",
		sportsTitle: "کھیل",
		sportsDesc: "فٹ بال، کرکٹ، NFL، ای-اسپورٹس اور 80 سے زائد کھیلوں پر شرط لگائیں",
		sportsBtn: "کھیلوں پر جائیں",
		liveTitle: "لائیو",
		liveDesc: "لائیو ڈیلرز کے ساتھ اصل وقت کا سنسنی خیز تجربہ",
		liveBtn: "لائیو پر جائیں"
	}
}